import type { BridgeResponse } from "./bridgeEvents";

import { BridgeError } from "@/shared/errors";
/**
 * Bridge 응답 검증
 *
 * 처리 순서:
 * 1. 문자열 응답이면 JSON 파싱
 * 2. resultCd 검사
 * 3. 실패 시 BridgeError 발생
 * 4. 정상 응답이면 결과 반환
 */
export function validateBridgeResponse<T>(response: unknown): T {
  try {
    const parsed = typeof response === "string" ? JSON.parse(response) : (response as BridgeResponse<T>);

    if (parsed.resultCd !== "0000") {
      throw new BridgeError(parsed.resultCd, parsed.resultMsg);
    }
    return parsed;
  } catch (error) {
    if (error instanceof BridgeError) {
      throw error;
    }

    if (error instanceof SyntaxError) {
      throw new Error("Bridge 응답 JSON 파싱 실패");
    }
    throw new Error("Bridge 응답 검증 실패");
  }
}
